module.exports = {"meta":{"description":"Puts people in our NPS Survey.","link":"https://trello.com/c/UlyUi0ym"},"audiences":["allMembers"],"experimentVersion":"v3","experimentAllocation":0.4,"defaultWeight":1,"defaults":{"showSurvey":false},"autoTrack":true,"variations":[{"name":"showSurvey","weight":1,"values":{"showSurvey":true}}]}


//////////////////
// WEBPACK FOOTER
// ./app/common/lib/experiments/config/npsSurvey.json
// module id = bGHy
// module chunks = 13